module.exports = __webpack_public_path__ + "6e8f24c0493774994be0f2c924c762c6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/x_corp_2023_chart.png
// module id = 1762
// module chunks = 0